import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { Toaster } from "sonner";

import {
  AuthProvider,
  useAuth,
} from "./context/AuthContext";

import { CartProvider } from "./context/CartContext";
import { SettingsProvider } from "./context/SettingsContext";
import { WishlistProvider } from "./context/WishlistContext";

import StoreLayout from "./components/storefront/StoreLayout";

import Home from "./pages/Home";
import Shop from "./pages/Shop";
import CategoryPage from "./pages/CategoryPage";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderSuccess from "./pages/OrderSuccess";
import Login from "./pages/Login";
import Register from "./pages/Register";
import InfoPage from "./pages/InfoPage";
import Wishlist from "./pages/Wishlist";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./components/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminCustomers from "./pages/admin/AdminCustomers";
import AdminAppearance from "./pages/admin/AdminAppearance";
import AdminPages from "./pages/admin/AdminPages";
import AdminBrands from "./pages/admin/AdminBrands";
import AdminNewsletter from "./pages/admin/AdminNewsletter";

// =========================================================
// ADMIN ROUTE
// =========================================================

function AdminRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#536D61]">
        Φόρτωση...
      </div>
    );
  }

  if (!user || user.role !== "admin") {
    return (
      <Navigate
        to="/admin/login"
        replace
      />
    );
  }

  return children;
}

// =========================================================
// APP
// =========================================================

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
          <CartProvider>
            <WishlistProvider>
              <BrowserRouter>

                <Toaster
                  position="top-center"
                  richColors
                />

                <Routes>

                  {/* =================================================
                      STOREFRONT
                  ================================================== */}

                  <Route element={<StoreLayout />}>

                    {/* HOME */}

                    <Route
                      path="/"
                      element={<Home />}
                    />

                    {/* ALL PRODUCTS */}

                    <Route
                      path="/shop"
                      element={<Shop />}
                    />

                    {/* =================================================
                        SEO CATEGORY URLS

                        Υποστηρίζει:

                        /category/face-care

                        /category/face-care/cleansers

                        /category/womens-care

                        /category/womens-care/intimate-care

                        /category/dietary-supplements-vitamins

                        /category/dietary-supplements-vitamins/vitamins

                        Το CategoryPage αναλαμβάνει να
                        διαβάσει ολόκληρο το pathname.
                    ================================================== */}

                    <Route
                      path="/category/*"
                      element={<CategoryPage />}
                    />

                    {/* PRODUCT */}

                    <Route
                      path="/product/:slug"
                      element={<ProductDetail />}
                    />

                    {/* CART */}

                    <Route
                      path="/cart"
                      element={<Cart />}
                    />

                    {/* WISHLIST */}

                    <Route
                      path="/wishlist"
                      element={<Wishlist />}
                    />

                    {/* CHECKOUT */}

                    <Route
                      path="/checkout"
                      element={<Checkout />}
                    />

                    {/* ORDER SUCCESS */}

                    <Route
                      path="/order/success"
                      element={<OrderSuccess />}
                    />

                    {/* LOGIN */}

                    <Route
                      path="/login"
                      element={<Login />}
                    />

                    {/* REGISTER */}

                    <Route
                      path="/register"
                      element={<Register />}
                    />

                    {/* INFORMATION PAGES */}

                    <Route
                      path="/page/:slug"
                      element={<InfoPage />}
                    />

                  </Route>

                  {/* =================================================
                      ADMIN LOGIN
                  ================================================== */}

                  <Route
                    path="/admin/login"
                    element={<AdminLogin />}
                  />

                  {/* =================================================
                      ADMIN
                  ================================================== */}

                  <Route
                    path="/admin"
                    element={
                      <AdminRoute>
                        <AdminLayout />
                      </AdminRoute>
                    }
                  >

                    <Route
                      index
                      element={<Dashboard />}
                    />

                    <Route
                      path="products"
                      element={<AdminProducts />}
                    />

                    <Route
                      path="categories"
                      element={<AdminCategories />}
                    />

                    <Route
                      path="orders"
                      element={<AdminOrders />}
                    />

                    <Route
                      path="customers"
                      element={<AdminCustomers />}
                    />

                    <Route
                      path="brands"
                      element={<AdminBrands />}
                    />

                    <Route
                      path="newsletter"
                      element={<AdminNewsletter />}
                    />

                    <Route
                      path="appearance"
                      element={<AdminAppearance />}
                    />

                    <Route
                      path="pages"
                      element={<AdminPages />}
                    />

                  </Route>

                </Routes>

              </BrowserRouter>
            </WishlistProvider>
          </CartProvider>
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;